import { gql, TypedDocumentNode } from "@apollo/client";

export type UpdatePersonProfilePhotoInput = {
  id: string;
  profilePhotoUrl: string;
};

export type UpdatePersonProfilePhotoResponse = {
  updatePerson: {
    success: boolean;
    message: string;
    code: number;
    person: {
      id: string;
      pgaId: string;
      profilePhoto: string;
    };
  };
};

export const UPDATE_PERSON_PROFILE_PHOTO_MUTATION: TypedDocumentNode<
  UpdatePersonProfilePhotoResponse,
  { input: UpdatePersonProfilePhotoInput }
> = gql`
  mutation UpdatePersonProfilePhoto($input: BackofficeUpdatePersonInput!) {
    updatePerson(input: $input) {
      success
      message
      code
      person {
        id
        pgaId
        profilePhoto
      }
    }
  }
`;
